module.exports = __webpack_public_path__ + "img/kruger_logo.79434027.svg";